import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AiSuggestRequest, AiSuggestResponse } from './symbols';

@Injectable()
export class AiService {
  private readonly apiUrl = '/api/ai';

  constructor(private http: HttpClient) {}

  suggest(req: AiSuggestRequest): Observable<AiSuggestResponse> {
    return this.http.post<AiSuggestResponse>(`${this.apiUrl}/suggest`, req);
  }
}
